<div class="are-you-sure-content-container">
  <div class="mat-headline-4 are-you-sure-text-container">
    {{ 'FLIP.DELETE.CONFIRM_TITLE' | translate }}
  </div>
  <div class="are-you-sure-text-container">
    {{ 'FLIP.DELETE.CONFIRM_MESSAGE' | translate }}
  </div>
  <div class="are-you-sure-button">
    <app-action-button
      kind="filled"
      color="warn"
      size="extra-wide"
      (onClick)="close(true)"
    >{{ 'FLIP.DELETE.CONFIRM_YES' | translate }}</app-action-button>
  </div>
  <div class="are-you-sure-button">
    <app-action-button
      kind="outline"
      color="primary"
      size="extra-wide"
      (onClick)="close(false)"
    >{{ 'FLIP.DELETE.CONFIRM_CANCEL' | translate }}</app-action-button>
  </div>
</div>
